import { render } from "./SupportPH.vue?vue&type=template&id=224badbe&scoped=true"
const script = {}

import "./SupportPH.vue?vue&type=style&index=0&id=224badbe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224badbe"]])

export default __exports__